var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0881 14.1832C26.0881 13.1823 26.0052 12.4518 25.8258 11.6943H14.1626V16.2122H21.0087C20.8707 17.3349 20.1253 19.0257 18.469 20.1619L18.4458 20.3132L22.1335 23.1129L22.389 23.1378C24.7354 21.0141 26.0881 17.8895 26.0881 14.1832",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1618 26.0871C17.5158 26.0871 20.3315 25.0049 22.3881 23.1383L18.4682 20.1623C17.4192 20.8793 16.0113 21.3797 14.1618 21.3797C10.8768 21.3797 8.08868 19.2561 7.09479 16.3208L6.94911 16.3329L3.1146 19.2412L3.06445 19.3778C5.10722 23.3546 9.30322 26.0871 14.1618 26.0871Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09561 16.3209C6.83336 15.5634 6.68159 14.7518 6.68159 13.9132C6.68159 13.0745 6.83336 12.2629 7.08181 11.5054L7.07486 11.3441L3.19229 8.38916L3.06526 8.44837C2.22333 10.0986 1.74023 11.9518 1.74023 13.9132C1.74023 15.8745 2.22333 17.7276 3.06526 19.3779L7.09561 16.3209",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1618 6.44649C16.4945 6.44649 18.0679 7.43392 18.9652 8.2591L22.471 4.90448C20.3179 2.94313 17.5159 1.73926 14.1618 1.73926C9.30326 1.73926 5.10723 4.47161 3.06445 8.4484L7.08102 11.5055C8.08871 8.57019 10.8768 6.44649 14.1618 6.44649",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9952d30e97179323c83cd63df575d95c.svg";
export { ForwardRef as ReactComponent };